import {
  ArchiveBoxIcon,
  TruckIcon,
  ShieldCheckIcon,
} from "@heroicons/react/20/solid";
import tentStorage from "../../assets/tentStorage.png";
import { Link } from "react-router-dom";

const features = [
  {
    name: "Season-end pickup.",
    description:
      "We’ll collect your team’s tent at the end of the season—no more cramming it into a garage or team van.",
    icon: TruckIcon,
  },
  {
    name: "Secure off-season storage.",
    description:
      "Your tent is stored at our climate-controlled, monitored facility. Protected from weather, pests, and forgetfulness.",
    icon: ShieldCheckIcon,
  },
  {
    name: "Pre-season delivery.",
    description:
      "When the next season starts, we’ll bring your tent to the field—clean, ready, and waiting.",
    icon: ArchiveBoxIcon,
  },
];

export default function StorageFeatures() {
  return (
    <div className="overflow-hidden bg-white">
      <div className="mx-auto max-w-7xl px-6 py-8 sm:py-8 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pt-4 lg:pr-8">
            <div className="lg:max-w-lg">
              <h2 className="text-base/7 font-semibold text-ttBlue-600">
                Now offering tent storage
              </h2>
              <p className="mt-2 text-4xl font-semibold tracking-tight text-pretty text-ttNavy-600 sm:text-5xl">
                Keep your tent safe between seasons
              </p>
              <p className="mt-6 text-lg/8 text-gray-500">
                Already own a team tent? Let us handle the off-season hassle.
                We’ll store it, maintain it, and return it to the field—just in
                time for opening day.
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-base/7 text-ttNavy-600 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="relative pl-9">
                    <dt className="inline font-semibold text-gray-900">
                      <feature.icon
                        aria-hidden="true"
                        className="absolute top-1 left-1 size-5 text-ttBlue-400"
                      />
                      {feature.name}
                    </dt>{" "}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
            {/* Pricing is based determined by size and duration of storage, so please contact us for a quote. */}
            <div className="mt-10">
              <p className="text-lg/8 text-gray-500">
                Pricing is determined by size and duration of storage, so please
                contact us for a quote.
              </p>
              <Link to="/contact">
                <div
                  aria-describedby="link-to-contact"
                  className="mt-8 block w-48 rounded-md bg-ttNavy-600 px-3.5 py-2 text-center text-sm font-semibold leading-6 text-white shadow-sm hover:bg-ttNavy-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ttNavy-600"
                >
                  Get a quote
                </div>
              </Link>
            </div>
          </div>

          <img
            alt="Tent storage and delivery service"
            src={tentStorage}
            className="w-full max-w-xl rounded-xl shadow-xl ring-1 ring-gray-400/10"
          />
        </div>
      </div>
    </div>
  );
}
